// Module Import
//---------------------------------
import React from 'react'
import styled from 'styled-components'
import { brandIvory } from '../../../assets/consts/color'

// Component Import
//---------------------------------

// Styled Component Declarations
//---------------------------------
const Wrapper = styled.div`
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: flex-start;
  background: ${brandIvory};
  margin: 0 0 40px 0;

  @media only screen and (min-width: 48em) {
    padding: 40px;
  }
`

// Component Export
//---------------------------------
export default function FormWrapper({ children }) {
  return <Wrapper>{children}</Wrapper>
}
